import { c as _c } from "react/compiler-runtime";
import { cn } from "@local/utils/src/cn";
import { Link } from "../../ui/Link";
import type { Offer } from "@local/offer/src/types";
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { category as categoryCatalog } from "@local/i18n/src/catalogs/category";
import Image from "next/image";
export const SingleCategoryCard = t0 => {
  const $ = _c(40);
  const {
    category,
    className,
    market
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== category.media?.url || $[1] !== category.name || $[2] !== category.slug || $[3] !== className || $[4] !== market) {
    const t = getT(getLanguageForMarket(market), {
      category: categoryCatalog
    });
    if ($[14] !== className) {
      t6 = cn("group relative", className);
      $[14] = className;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    const t9 = category.media?.url || "/images/marble_bg.png";
    let t10;
    if ($[16] !== t9) {
      t10 = getCdnUrl({
        src: t9
      });
      $[16] = t9;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    const t11 = <Link className="relative block h-full w-full" href={`/${market}/category/${category.slug}`} prefetch={false}><Image alt={category.name || t("category.collectionImageAlt")} src={t10} quality={75} fill={true} sizes="(max-width: 640px) 50vw, (max-width: 1024px) 25vw, 230px" className="object-cover" /></Link>;
    if ($[18] !== t11) {
      t7 = <div className="aspect-[3/4] w-full overflow-hidden"><div className="relative h-full w-full transform bg-cover bg-top transition-all duration-300 ease-in-out group-hover:scale-105">{t11}</div></div>;
      $[18] = t11;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    if ($[20] !== category.name || $[21] !== category.slug || $[22] !== market) {
      t8 = <h3 className="text-h5 leading-heading font-display mt-1 font-semibold uppercase">{category?.slug ? <Link href={`/${market}/category/${category.slug}`} prefetch={false} className={cn("relative block group-hover:underline")}><span className="absolute inset-0" />{category?.name}</Link> : <span className="relative block">{category?.name}</span>}</h3>;
      $[20] = category.name;
      $[21] = category.slug;
      $[22] = market;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    t5 = "text-base font-semibold uppercase md:text-lg";
    T0 = Link;
    t1 = `/${market}/category/${category.slug}`;
    t2 = false;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = cn("relative block group-hover:underline");
      $[24] = t3;
    } else {
      t3 = $[24];
    }
    t4 = t("category.exploreCategory");
    $[0] = category.media?.url;
    $[1] = category.name;
    $[2] = category.slug;
    $[3] = className;
    $[4] = market;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    T0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span>{">"}</span>;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== T0 || $[27] !== t1 || $[28] !== t2 || $[29] !== t3 || $[30] !== t4) {
    t10 = <T0 href={t1} prefetch={t2} className={t3}>{t4} {t9}</T0>;
    $[26] = T0;
    $[27] = t1;
    $[28] = t2;
    $[29] = t3;
    $[30] = t4;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t5) {
    t11 = <div className={t5}>{t10}</div>;
    $[32] = t10;
    $[33] = t5;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t11 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8) {
    t12 = <div className={t6}>{t7}{t8}{t11}</div>;
    $[35] = t11;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  return t12;
};